import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/tracking";

export const WA_NUMBER = "393923598141";
export const WA_URL = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent("Buongiorno, vorrei informazioni sul recupero di un deposito dormiente.")}`;

export const WhatsAppIcon = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.94.95-3.48-.22-.36a9.43 9.43 0 0 1-1.45-5.02c0-5.2 4.24-9.44 9.45-9.44 2.52 0 4.89.99 6.67 2.77a9.37 9.37 0 0 1 2.76 6.68c0 5.21-4.24 9.44-9.44 9.44m8.04-17.48A11.3 11.3 0 0 0 12.05.7C5.78.7.68 5.8.68 12.07c0 2 .52 3.96 1.52 5.68L.58 23.7l6.09-1.6a11.36 11.36 0 0 0 5.37 1.37h.01c6.27 0 11.37-5.1 11.37-11.37 0-3.04-1.18-5.9-3.33-8.05" />
  </svg>
);

export const WhatsAppButton = () => {
  const loc = useLocation();
  if (loc.pathname.startsWith("/studio")) return null;
  return (
    <a href={WA_URL} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float-btn" aria-label="Scrivici su WhatsApp"
      onClick={() => trackEvent("Contact", { method: "whatsapp" })}
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] pl-3.5 pr-3.5 sm:pr-5 h-14 transition-transform hover:scale-105 active:scale-95">
      <WhatsAppIcon className="h-7 w-7" />
      <span className="hidden sm:inline text-sm font-semibold">Scrivici su WhatsApp</span>
    </a>
  );
};
